import { render } from "./DetailedAnalyticsModal.vue?vue&type=template&id=1405f4f8&scoped=true"
import script from "./DetailedAnalyticsModal.vue?vue&type=script&lang=js"
export * from "./DetailedAnalyticsModal.vue?vue&type=script&lang=js"

import "./DetailedAnalyticsModal.vue?vue&type=style&index=0&id=1405f4f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1405f4f8"]])

export default __exports__